
      <div class="toolbar" role="banner">
          <img alt="Angular Logo" src="assets/images/jpm-logo.png" />
          <span>JPMC Payment</span>
          <div class="spacer"></div>
        </div>
        
        <img src="assets/images/trimble.jpg" class="img-propare" />
        <div class="card-container container" role="main">
          
          <div class="content" role="main">
            <div class="row">
              <div class="col-lg-3">
                <div class="image-field">
                  <img src="assets/images/Trimble_Logo.png">
                  <h4>Trimble Solutions India Private Ltd</h4>
                </div>
              </div>
        
              <div class="col-lg-9">
                <section class="example-section">
                    <form [formGroup]="form">
                      <h4 class="example-section">Payment Details</h4>
                      <mat-grid-list cols="3" rowHeight="80px" gutterSize="15px">
        
                        <mat-form-field appearance="outline">
                          <mat-label>First Name</mat-label>
                          <input type="text" maxlength="100" matInput formControlName="firstName" placeholder="Enter First Name" onkeypress='return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || event.charCode == 32' required>
                          <mat-error *ngIf="form.controls['firstName'].hasError('required')">First Name is required.</mat-error>
                          <mat-error *ngIf="form.controls['firstName'].hasError('pattern')">Invalid First Name</mat-error>
                        </mat-form-field>
        
                        <mat-form-field appearance="outline">
                          <mat-label>Last Name</mat-label>
                          <input type="text" matInput formControlName="lastName" placeholder="Enter Last Name" onkeypress='return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || event.charCode == 32' required>
                          <mat-error *ngIf="form.controls['lastName'].hasError('required')">Last Name is required.</mat-error>
                          <mat-error *ngIf="form.controls['lastName'].hasError('pattern')">Invalid Last Name</mat-error>
                        </mat-form-field>
        
                        <mat-form-field appearance="outline">
                          <mat-label>Email ID</mat-label>
                          <input type="text" matInput formControlName="emailId" placeholder="Enter Email ID" required>
                          <mat-error *ngIf="form.controls['emailId'].hasError('required')">Email ID is required.</mat-error>
                          <mat-error *ngIf="form.controls['emailId'].hasError('pattern')">Invalid Email ID</mat-error>
                        </mat-form-field>
        
                      </mat-grid-list>
                      
                      <mat-grid-list cols="3" rowHeight="80px" gutterSize="15px">
        
                        <mat-form-field appearance="outline">
                          <mat-label>Company Name</mat-label>
                          <input type="text" matInput formControlName="companyName" placeholder="Enter Company Name" required>
                          <mat-error *ngIf="form.controls['companyName'].hasError('required')">Company Name is required.</mat-error>
                          <mat-error *ngIf="form.controls['companyName'].hasError('pattern')">Invalid Company Name</mat-error>
                        </mat-form-field>
        
                        <mat-form-field appearance="outline">
                          <mat-label>Mobile Number</mat-label>
                          <input type="number" matInput max="10" min="10" (keydown)="maxValue($event)" formControlName="mobileNo" placeholder="Enter Mobile Number" required>
                          <mat-error *ngIf="form.controls['mobileNo'].hasError('required')">Mobile Number is required.</mat-error>
                          <mat-error *ngIf="form.controls['mobileNo'].hasError('pattern')">Invalid Mobile Number</mat-error>
                        </mat-form-field>
        
                        <mat-form-field appearance="outline">
                          <mat-label>Customer ID</mat-label>
                          <input type="text" matInput formControlName="customerId" placeholder="Enter Customer ID" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || event.charCode == 32">
                          <mat-error *ngIf="form.controls['customerId'].hasError('pattern')">Invalid Customer Id</mat-error>
                        </mat-form-field>
        
                      </mat-grid-list>
        
                      <mat-grid-list cols="3" rowHeight="70px" gutterSize="15px">
        
                        <!-- <mat-form-field appearance="outline">
                          <mat-label>Invoice Number</mat-label>
                          <input type="text" matInput formControlName="invoiceNumber" placeholder="Enter Invoice Number" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || event.charCode == 32" required>
                          <mat-error *ngIf="form.controls['invoiceNumber'].hasError('required')">Invoice Number is required.</mat-error> 
                          <mat-error *ngIf="form.controls['invoiceNumber'].hasError('pattern')">Invalid Invoice Number</mat-error>
                        </mat-form-field> -->

                        <mat-form-field appearance="outline">
                            <mat-label>Invoice Number</mat-label>
                            <input type="text" matInput formControlName="invoiceNumber" placeholder="Enter Invoice Number"
                                   onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || event.charCode == 32 || event.charCode == 45"
                                   required>
                            <mat-error *ngIf="form.controls['invoiceNumber'].hasError('required')">Invoice Number is required.</mat-error>
                            <mat-error *ngIf="form.controls['invoiceNumber'].hasError('pattern')">Invalid Invoice Number</mat-error>
                          </mat-form-field>
        
                        <mat-form-field appearance="outline">
                          <mat-label>Invoice Amount</mat-label>
                          <input type="text" matInput formControlName="invoiceAmount" placeholder="Enter Invoice Amount" required>
                          <mat-error *ngIf="form.controls['invoiceAmount'].hasError('required')">Invoice Amount is required.</mat-error>
                          <mat-error *ngIf="form.controls['invoiceAmount'].hasError('pattern')">Invalid Invoice Amount</mat-error>
                        </mat-form-field>
  <!--       
                        <mat-form-field appearance="outline">
                          <mat-label>INR</mat-label>
                          <input type="text" matInput [formControl]="inr" placeholder="INR">
                        </mat-form-field> -->
        
                      </mat-grid-list>
        
                      <mat-grid-list cols="2" rowHeight="30px" gutterSize="15px">
        
                        <section class="example-section">
                          <!-- <mat-checkbox class="example-margin">I accept below Terms & Conditions</mat-checkbox> -->
                          <mat-checkbox id="checkbox" [(ngModel)]="checkboxValue" [ngModelOptions]="{standalone: true}">
                              I accept below <a href="#" (click)="openTermsAndConditionsPopup($event)">Terms & Conditions</a>
                            </mat-checkbox>
                            <mat-error *ngIf="formSubmitted && !checkboxValue">You must accept the terms and conditions.</mat-error>        
                          
                           </section>
        
                      </mat-grid-list>

                      <mat-grid-list cols="2" rowHeight="90px" gutterSize="15px">
        
                          <section class="example-section">
                                 
                              <mat-form-field appearance="outline" style="margin-left:0px !important;">
                                  <mat-label>INR</mat-label>
                                  <input type="text" matInput value="{{this.form.controls.invoiceAmount.value | number}}" formControlName="inrAmount" [value]="invoiceAmount" readonly>
                                  <!-- <span matSuffix class="amount"> {{ ' ' + (invoiceAmount?.toString() || '0') | number }}</span> -->
                                </mat-form-field>                         
                           
                            <button mat-raised-button color="primary" type="submit" (click)="submitTrimbleDetails()" class="button-left">PAY NOW</button>
                        
                           </section>
          
                        </mat-grid-list>
                   </form>   
                </section>
              </div>
              
        <div>
          <form
            target="_top"
            #txnForm
            [formGroup]="tranxnForm"
            method="POST"
            action="{{ isgPay_url }}"
          >
            <input
              type="hidden"
              [value]="EncDataField"
              name="EncData"
              formControlName="EncData"
            />
            <input
              type="hidden"
              [value]="MerchantIdField"
              name="MerchantId"
              formControlName="MerchantId"
            />
            <input
              type="hidden"
              [value]="BankIdField"
              name="BankId"
              formControlName="BankId"
            />
            <input
              type="hidden"
              [value]="TerminalIdField"
              name="TerminalId"
              formControlName="TerminalId"
            />
            <input
              type="hidden"
              [value]="VersionField"
              name="Version"
              formControlName="Version"
            />
            <input
              type="hidden"
              [value]="TransactionId"
              name="OrderId"
              formControlName="TransactionId"
            />

            <input 
            type="hidden" 
            [value]="emailId" 
            name="Email" 
            formControlName="emailId"
            />

            <input 
            type="hidden" 
            [value]="mobileNo" 
            name="Phone" 
            formControlName="mobileNo"
            />

            <input 
            type="hidden" 
            [value]="firstName" 
            name="FirstName" 
            formControlName="firstName"
            />

            <input 
            type="hidden" 
            [value]="lastName" 
            name="LastName" 
            formControlName="lastName"
           />

          </form>
        </div>
            </div>
          </div>
        </div>
        
        <div class="footer" role="banner">
        
          <mat-grid-list cols="2" rowHeight="50px" gutterSize="15px">
        
            <section class="example-section">
               <img alt="Angular Logo" src="assets/images/poweredBy.png" class="img-center" /> 
            </section>
        
          </mat-grid-list>
        
          <mat-grid-list cols="2" rowHeight="50px" gutterSize="15px">
        
            <section class="example-section top-space">
                <img alt="Angular Logo" src="assets/images/UPI.svg" class="img-logos" />
                <img alt="Angular Logo" src="assets/images/RuPay.svg" class="img-logos" />
                <img alt="Angular Logo" src="assets/images/VISA.svg" class="img-logos" />
                <img alt="Angular Logo" src="assets/images/MasterCard.svg" class="img-logos" />
            </section>
        
          </mat-grid-list>
        
        </div>

        
        <!-- <router-outlet></router-outlet> -->
        <!-- <app-trimble-fee-details></app-trimble-fee-details> -->
  
      <!-- </div>
    </div>
  </div> -->
  
  
  <!-- <ng-template #confirmMblBox >
    <img src="assets/images/sucess.png" class="md-card-image" alt="image caption" />
    <br>
    <mat-dialog-content style="text-align: center">
      Your complaint has been registered <br>
      successfully. <br>
      Mention below reference number <br>
      for further inquiry.
      <br>
      <h2 class="mat-h2">Reference number : </h2>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button  [mat-dialog-close] color="primary"  class=" BTN"  > OK </button>
    </mat-dialog-actions>
  </ng-template> -->

     
 